import { render, staticRenderFns } from "./GovernanceDetail.vue?vue&type=template&id=d2a690b8&scoped=true"
import script from "./GovernanceDetail.vue?vue&type=script&lang=js"
export * from "./GovernanceDetail.vue?vue&type=script&lang=js"
import style0 from "./GovernanceDetail.vue?vue&type=style&index=0&id=d2a690b8&prod&lang=css"
import style1 from "./GovernanceDetail.vue?vue&type=style&index=1&id=d2a690b8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d2a690b8",
  null
  
)

export default component.exports